import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Campo password con icona a occhio per mostrare/nascondere il testo digitato.
export const PasswordInput = ({ value, onChange, testId, className = "", ...props }) => {
    const [show, setShow] = useState(false);
    return (
        <div className="relative mt-1.5">
            <input
                {...props}
                type={show ? "text" : "password"}
                value={value}
                onChange={onChange}
                data-testid={testId}
                className={`w-full rounded-xl border border-slate-200 py-3 pl-4 pr-12 text-base font-normal normal-case tracking-normal text-[#0B1F3A] outline-none focus:border-[#0B1F3A] ${className}`}
            />
            <button
                type="button"
                onClick={() => setShow((v) => !v)}
                aria-label={show ? "Nascondi password" : "Mostra password"}
                aria-pressed={show}
                data-testid={`${testId}-toggle`}
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded-lg p-2 text-[#4F5D70] hover:bg-slate-100 hover:text-[#0B1F3A]"
            >
                {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
            </button>
        </div>
    );
};
